import { ParticipantMarketType } from '@cds/betting-offer';

import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { ParticipantPickType } from '../../../../../core/picks/pick-models';
import { BetslipV2OptionMarketXCastRacePick } from '../../../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { isRacePick } from '../../../../picks/services/betslip-pick-helpers';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates V2 participant option picks for combo.
 */
export class V2OptionMarketXCastV2ParticipantComboPrevention extends BaseComboPrevention<
    BetslipV2OptionMarketXCastRacePick,
    BetslipV2ParticipantPick
> {
    constructor() {
        super(BetslipV2OptionMarketXCastRacePick, BetslipV2ParticipantPick);
    }

    validate(thisPick: BetslipV2OptionMarketXCastRacePick, otherPick: BetslipV2ParticipantPick, isSystemBet: boolean): ComboPreventionResult {
        if (thisPick.market.marketType === ParticipantMarketType.Tricast) {
            // Tricast is not combinable.
            return ComboPreventionResult.RaceTricast;
        }
        if (thisPick.market.marketType === ParticipantMarketType.Forecast && otherPick.market.marketType !== ParticipantMarketType.Forecast) {
            // Forecast pick can be combinable only with other forecast picks.
            return ComboPreventionResult.OnlyRaceForecast;
        }

        if (isSystemBet && isRacePick(otherPick) && otherPick.id.pickType === ParticipantPickType.CombinationForecast) {
            return ComboPreventionResult.SystemCombinationForecast;
        }

        if (thisPick.fixture.fixtureId === otherPick.fixture.fixtureId) {
            return ComboPreventionResult.SameFixture;
        }

        return ComboPreventionResult.AllCombo;
    }
}
